import React from "react";
import { useTranslation } from "react-i18next";
import Actions from "../../../../../Actions";

import { Store__System, CustomerSucessController } from "@talentbait/shared-components";

import {
  TopUpCreditsContainer,
  TopUpCreditsText,
  TopUpCreditsLearnMore,
  TopUpCreditsButton
} from "./TopUpCredits.styled";
import { withRefluxStore } from "../../../../../Stores";

const TopUpCredits = ({ user, organization }) => {
  const { t } = useTranslation();

  const emitIntercomArticle = (event) => {
    event.preventDefault();

    CustomerSucessController.send("Checkout topup article opened", {
      user_id: user?.uid,
      organization_id: organization?.id,
      user_name: user?.displayName,
      organization_name: organization?.name
    });

    if (window.Intercom) {
      window.Intercom("showArticle", 6329714);
    }
  };

  const emitCreditModal = (event) => {
    event.preventDefault();

    CustomerSucessController.send("Checkout topup clicked", {
      user_id: user?.uid,
      organization_id: organization?.id,
      user_name: user?.displayName,
      organization_name: organization?.name
    });

    Actions.showCreditModal();
  };

  return (
    <TopUpCreditsContainer>
      <TopUpCreditsText>
        {t("You save up to 20% by paying with credit!")}
        <TopUpCreditsLearnMore onClick={emitIntercomArticle}>
          {t("Learn more")}
        </TopUpCreditsLearnMore>
      </TopUpCreditsText>
      <TopUpCreditsButton onClick={emitCreditModal}>{t("Top up now")}</TopUpCreditsButton>
    </TopUpCreditsContainer>
  );
};

export default withRefluxStore(TopUpCredits, [Store__System], ["user", "organization"]);
